import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/format';

export type ChipVariant =
  | 'default'
  | 'active'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info';

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
}

export function Chip({ variant = 'default', className, children, ...rest }: ChipProps) {
  const variantClass = {
    default: 'bg-line/50 text-ink-subtle',
    active: 'bg-primary text-white',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    danger: 'bg-danger/10 text-danger',
    info: 'bg-primary/10 text-primary',
  }[variant];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full text-caption font-medium px-3 py-1',
        variantClass,
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
